import React, { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { Col, Row } from '../atoms/Grid'
import { BtPlainText } from '@linqpal/components/src/ui'

interface IDataRow {
  name: string
  value: any
}

interface IProps {
  theme?: 'gray' | 'white'
  data: IDataRow[]
}

export const PropertyList: FC<IProps> = ({ theme, data }) => {
  const containerStyle = theme === 'gray' ? styles.containerGray : undefined

  return (
    <View style={containerStyle}>
      {data.map((item, index) => (
        <View key={`${index}-${item.name}`}>
          <Row style={index < data.length - 1 ? styles.row : styles.lastRow}>
            <Col>
              <BtPlainText weight="500">{item.name}</BtPlainText>
            </Col>
            <Col style={styles.rightColumn}>
              <BtPlainText weight="700">{item.value}</BtPlainText>
            </Col>
          </Row>
        </View>
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  containerGray: {
    backgroundColor: '#F8F9F9',
    borderRadius: 8,
    padding: 20,
  },
  row: {
    borderBottomColor: '#DEE5EB',
    borderBottomWidth: 1,
    paddingBottom: 15,
    marginBottom: 15,
  },
  lastRow: {
    borderBottomWidth: 0,
    paddingBottom: 0,
    marginBottom: 0,
  },
  rightColumn: {
    marginLeft: 'auto',
  },
})
